import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_DELETE_COLLECTION_QUERY_BEGIN,
  COLLECTIONS_DELETE_COLLECTION_QUERY_SUCCESS,
  COLLECTIONS_DELETE_COLLECTION_QUERY_FAILURE,
  COLLECTIONS_DELETE_COLLECTION_QUERY_DISMISS_ERROR,
} from './constants';

import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function deleteCollectionQuery(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_DELETE_COLLECTION_QUERY_BEGIN,
    });
    const { projectId, collectionUuid, finderId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/finders/${collectionUuid}/collection/${finderId}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_DELETE_COLLECTION_QUERY_SUCCESS,
              data: res.data,
              collectionUuid,
            });
            Mixpanel.track('Deleted collection filter');
            toast.success('Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_DELETE_COLLECTION_QUERY_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to delete collection filter');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_DELETE_COLLECTION_QUERY_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to delete collection filter');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteCollectionQueryError() {
  return {
    type: COLLECTIONS_DELETE_COLLECTION_QUERY_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_DELETE_COLLECTION_QUERY_BEGIN:
      return {
        ...state,
        deleteCollectionQueryPending: true,
        deleteCollectionQueryError: null,
      };

    case COLLECTIONS_DELETE_COLLECTION_QUERY_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      projectCollections[index].finders = action.data;
      return {
        ...state,
        deleteCollectionQueryPending: false,
        deleteCollectionQueryError: null,
        projectCollections,
        selectedCollection: {
          ...state.selectedCollection,
          finders: action.data,
        },
      };

    case COLLECTIONS_DELETE_COLLECTION_QUERY_FAILURE:
      return {
        ...state,
        deleteCollectionQueryPending: false,
        deleteCollectionQueryError: action.data.error,
      };

    case COLLECTIONS_DELETE_COLLECTION_QUERY_DISMISS_ERROR:
      return {
        ...state,
        deleteCollectionQueryError: null,
      };

    default:
      return state;
  }
}
